import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-application-status',
  imports: [SharedModule],
  templateUrl: './application-status.component.html',
  styleUrl: './application-status.component.scss'
})
export class ApplicationStatusComponent {

  @Input() currentStatus: string = 'Raw';

  statuses = ['In Progress','Completed','Canceled'];

  getStatusClass(status: string): string {
    const currentIndex = this.statuses.indexOf(this.currentStatus);
    const statusIndex = this.statuses.indexOf(status);

    if (statusIndex < currentIndex) {
      return 'completed'; // Previous steps (dark)
    } else if (statusIndex === currentIndex) {
      return 'current'; // Current step (yellow)
    } else {
      return 'upcoming'; // Upcoming steps (light)
    }
  }
}
